import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-confirm-stage-dialog',
  templateUrl: './confirm-stage-dialog.component.html',
  styleUrl: './confirm-stage-dialog.component.css'
})
export class ConfirmStageDialogComponent implements OnInit {
  form: FormGroup;
  project: any;
  staffList: any[] = [];
  isLoadingStaff: boolean = true;
  stages: any[] = [
    {id: 1, name: 'Pre-Planning'}, 
    {id: 2, name: 'Planning'}, 
    {id: 3, name: 'Survey'}, 
    {id: 4, name: 'Design Revisions & Scope Adjustments'}, 
    {id: 5, name: 'Execution'}, 
    {id: 6, name: 'Closure'}
  ];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ConfirmStageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { project: any, itemName: string },
    private apiService: ApiService
  ) {
    this.project = data.project;
    
    this.form = this.fb.group({
      name: [this.project?.project_name || '', Validators.required],
      stages: [this.project?.stage || '', Validators.required],
      assigned_to: [this.project?.assigned_to || '', Validators.required],
      date: [this.project?.stage_date || '', Validators.required],
    });
  }

  ngOnInit(): void {
    this.fetchStaff();
  }

  fetchStaff() {
    this.isLoadingStaff = true;
    const params = { keyword: "" };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        console.log('Staff data:', res);
        this.staffList = res.data || [];
        
        // Update the assigned lead form control if project has an assigned staff member
        if (this.project?.assigned_to && this.staffList.length > 0) {
          const assignedStaff = this.staffList.find(staff => 
            staff.personnel_id === this.project.assigned_to || 
            staff.first_name + ' ' + staff.last_name === this.project.assigned_to
          );
          if (assignedStaff) {
            this.form.patchValue({ assigned_to: assignedStaff.personnel_id });
          }
        }
        this.isLoadingStaff = false;
      },
      error: (err) => {
        console.error('Error fetching staff:', err);
        this.isLoadingStaff = false;
      },
      complete: () => console.log('Staff fetch complete'),
    });
  }

  getSelectedStaffName(): string {
    const selectedStaffId = this.form.get('assigned_to')?.value;
    const selectedStaff = this.staffList.find(staff => staff.personnel_id === selectedStaffId);
    return selectedStaff ? `${selectedStaff.first_name} ${selectedStaff.last_name}` : '';
  }

  submit() {
    if (this.form.valid) {
      const formData = {
        ...this.form.value,
        projectId: this.project?.id,
        currentStage: this.project?.stage,
        assignedStaffName: this.getSelectedStaffName()
      };
      this.dialogRef.close(formData);
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
